import { makeObservable, observable, action } from 'mobx';
import { camelizeKeys } from 'humps';
import RatingApi from '../api/ratingApi';
import logger from '../logger';
import strings from '../strings';

class RatingStore {
  firms = [];
  totalFirmsCount = 0;
  isLoading = false;

  constructor() {
    makeObservable(this, {
      firms: observable,
      totalFirmsCount: observable,
      isLoading: observable,
      fetch: action,
      setIsLoading: action,
      setFirms: action,
      setTotalFirmsCount: action,
    });
  }

  fetch = async (requestObject) => {
    try {
      this.setIsLoading(true);
      const response = await RatingApi.getRating(requestObject || {});
      const normalized = camelizeKeys(response);

      this.setFirms(normalized.firms);
      this.setTotalFirmsCount(normalized.totalFirmsCount);
      if (normalized.firms) {
        this.setIsLoading(false);
      }
      return normalized;
    } catch (error) {
      logger.error(error, strings.requestError);
      return error;
    }
  }

  setIsLoading = (value) => {
    this.isLoading = value;
  }

  setFirms = (firms) => {
    this.firms = firms;
  }

  setTotalFirmsCount = (count) => {
    this.totalFirmsCount = count;
  }
}

export default RatingStore;
